import { Table, Button, Input, Select } from "antd";
import { useState } from "react";

export default function TransactionTable({
  transactions,
  deleteTransaction,
}) {
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("all");

  const filteredTransactions = transactions.filter((transaction) => {
    const matchesSearch = transaction.name
      .toLowerCase()
      .includes(search.toLowerCase());

    const matchesType =
      typeFilter === "all"
        ? true
        : transaction.type.toLowerCase() === typeFilter;

    return matchesSearch && matchesType;
  });

  const exportCSV = () => {
    const csvRows = [
      ["Name", "Type", "Date", "Amount"],
      ...transactions.map((t) => [
        t.name,
        t.type,
        t.date,
        t.amount,
      ]),
    ];

    const blob = new Blob(
      [csvRows.map((r) => r.join(",")).join("\n")],
      { type: "text/csv" }
    );

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "transactions.csv";
    a.click();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount - b.amount,
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button danger onClick={() => deleteTransaction(record.id)}>
          Delete
        </Button>
      ),
    },
  ];

  return (
    <div style={{ marginTop: "40px" }}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        <Input
          placeholder="Search by Name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <Select
          value={typeFilter}
          onChange={setTypeFilter}
          style={{ width: 180 }}
          options={[
            { value: "all", label: "All" },
            { value: "income", label: "Income" },
            { value: "expense", label: "Expense" },
          ]}
        />

        <Button onClick={exportCSV}>Export CSV</Button>
      </div>

      <h2>My Transactions</h2>

      <Table
        dataSource={filteredTransactions}
        columns={columns}
        rowKey="id"
      />
    </div>
  );
}